import React, { useEffect } from 'react';
import $ from 'jquery';

const ConfirmationModal = ({ show, modalText, handleConfirm, handleCancel }) => {
  useEffect(() => {
    if (show) $('#confirmationModal').modal('show');
    else $('#confirmationModal').modal('hide');
  }, [show]);

  return (
    <div
      className="modal"
      id="confirmationModal"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-md" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="m-0">Confirmation</h4>
          </div>
          <div className="modal-body">
            <p className="font-weight-bold">{modalText}</p>
          </div>
          <div className="modal-footer d-flex justify-content-between py-0">
            <button
              className="my-account-btn secondary"
              data-dismiss="modal"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="my-account-btn"
              data-dismiss="modal"
              onClick={handleConfirm}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
